import { type User } from '@/lib/types';
import { createContext } from 'react';

const SelectedUserContext = createContext<User | null>(null);

export default SelectedUserContext;
